import React from 'react';
import Icon from '@components/Icon/Icon';
import './ExampleIcons.scss';

const ExampleIcons = () => {
  return (
    <div className="example-icons">
      <h2>Font Awesome Icons Examples</h2>

      <div className="icon-section">
        <h3>Basic Icons</h3>
        <Icon icon="home" size="2x" />
        <Icon icon="user" size="2x" />
        <Icon icon="search" size="2x" />
        <Icon icon="bars" size="2x" />
      </div>

      <div className="icon-section">
        <h3>Colored Icons</h3>
        <Icon icon="heart" size="2x" color="#e74c3c" />
        <Icon icon="star" size="2x" color="#f39c12" />
        <Icon icon="check" size="2x" color="#27ae60" />
        <Icon icon="exclamation-triangle" size="2x" color="#f1c40f" />
      </div>

      <div className="icon-section">
        <h3>Animated Icons</h3>
        <Icon icon="spinner" size="2x" spin />
        <Icon icon="heart" size="2x" pulse color="#e74c3c" />
        <Icon icon="cog" size="2x" spin />
      </div>

      <div className="icon-section">
        <h3>Brand Icons</h3>
        <Icon icon={['fab', 'facebook']} size="2x" color="#3b5998" />
        <Icon icon={['fab', 'twitter']} size="2x" color="#1da1f2" />
        <Icon icon={['fab', 'instagram']} size="2x" color="#e4405f" />
        <Icon icon={['fab', 'github']} size="2x" color="#333" />
      </div>

      <div className="icon-section">
        <h3>Regular Icons</h3>
        <Icon icon={['far', 'heart']} size="2x" />
        <Icon icon={['far', 'star']} size="2x" />
        <Icon icon={['far', 'user']} size="2x" />
      </div>

      <div className="icon-section">
        <h3>Clickable Icons</h3>
        <Icon
          icon="edit"
          size="2x"
          className="icon--clickable"
          onClick={() => alert('Edit clicked!')}
        />
        <Icon
          icon="trash"
          size="2x"
          className="icon--clickable"
          color="#dc3545"
          onClick={() => alert('Delete clicked!')}
        />
      </div>
    </div>
  );
};

export default ExampleIcons;